<div class="upgrade-feature-banner" *ngIf="!featureEnabled">
  <div class="flex-space-between" style="align-items: center">
    Upgrade to automatically generate articles from conversation history
    <ion-button fill="outline" color="light" class="btn-small" routerLink="/upgrade">
      <ion-icon name="arrow-up-circle" class="padded-icon"></ion-icon>
      Upgrade account
    </ion-button>
  </div>
</div>

<ion-grid class="grid">
  <ion-row>
    <ion-col size="12">
      <div class="flex-space-between flexed-align-center" style="padding: 0 13px">
        <div>
          <h2>Suggested Articles to Create</h2>
          <p class="subtitle">Review conversations to have an AI generate a knowledge base article.</p>
        </div>
      </div>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12">
      <ion-card class="outline-card" *ngIf="featureEnabled">
        <div class="button-container flexed-align-center">
          <div class="flexed-align-center">
            <ion-searchbar
              mode="ios"
              class="rounded-search-bar"
              placeholder="Search..."
              showCancelButton="never"
              [(ngModel)]="searchText"
              (ionChange)="handleFilters()"
            >
            </ion-searchbar>

            <app-filter-button
              [options]="filterOptions"
              (didChange)="filtersDidChange($event)"
              [selected]="filters"
              [projectId]="authService.selectedProject?.id ?? undefined"
            ></app-filter-button>
          </div>
        </div>

        <ngx-datatable
          class="material fullscreen datatable-row-borders datatable-row-top-aligned"
          [columnMode]="ColumnMode.flex"
          [limit]="100"
          [headerHeight]="50"
          [footerHeight]="50"
          rowHeight="auto"
          [scrollbarH]="true"
          [reorderable]="true"
          [selectAllRowsOnPage]="false"
          [loadingIndicator]="isLoading"
          paginated
          [dataSource]="suggestionsDataSource"
        >
          <ngx-datatable-column name="Conversation" prop="content" [flexGrow]="2.5" [sortable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class="summary-container">
                <a
                  *ngIf="row.resolvedTitle"
                  routerLink="/dashboard/inbox/all/conversations/{{ row.id }}"
                  class="row-title row-link"
                  style="font-size: 1rem"
                  href="/dashboard/inbox/all/conversations/{{ row.id }}"
                  >{{ formatContent(row) }}
                </a>
                <i *ngIf="!row.resolvedTitle">None</i>
                <div class="flex-space-between" *ngIf="row.summary" style="margin: 10px 0">
                  <ion-icon
                    name="sparkles-outline"
                    style="font-size: 1.1rem; margin-right: 6px; color: goldenrod"
                  ></ion-icon>
                  <span style="width: 100%; font-size: 0.8rem">{{ row.summary }}</span>
                </div>
                <div style="margin-top: 10px; margin-bottom: 5px">
                  <ion-button
                    *ngIf="!row.knowledgeBaseArticle"
                    (click)="generateArticle(row)"
                    [disabled]="isLoading || !featureEnabled"
                    class="no-margin"
                  >
                    Generate article
                    <ion-icon name="lock-closed" class="icon-padded-left" *ngIf="!featureEnabled"></ion-icon>
                  </ion-button>
                  <ion-button
                    *ngIf="!row.knowledgeBaseArticle"
                    fill="clear"
                    (click)="ignoreArticle(row)"
                    [disabled]="isLoading || !featureEnabled"
                    class="no-margin"
                  >
                    Dismiss
                    <ion-icon name="lock-closed" class="icon-padded-left" *ngIf="!featureEnabled"></ion-icon>
                  </ion-button>
                  <ion-button *ngIf="row.knowledgeBaseArticle" color="light" [disabled]="true" class="no-margin">
                    <ion-icon name="checkmark-outline"></ion-icon>
                    <span class="text-with-left-icon hidden-sm"> Added </span>
                  </ion-button>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Tags" [flexGrow]="1" [sortable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <ion-badge
                color="success"
                *ngFor="let tag of row.tags"
                class="clickable"
                (click)="editTagForSuggestion(row.id, tag.id, $event)"
              >
                <span [title]="getTagsForRow(row)"> {{ tag.name }} </span>
              </ion-badge>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            [name]="authService.tenant.accountsEnabled ? 'Channel' : 'Customer'"
            prop="customer?.name"
            [flexGrow]="1"
            [sortable]="false"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.customer?.name }}
              <i *ngIf="!row.customer?.name">None</i>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Project" prop="project?.name" [flexGrow]="1" [sortable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.project?.name }}
              <i *ngIf="!row.project?.name">None</i>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Submitted" prop="createdAt" [flexGrow]="0.8" [sortable]="false">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <span title="{{ value | date: 'MMM d yyyy h:mm a' }}">{{ displayDate(value) }}</span>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-grid>
